// extracted by mini-css-extract-plugin
module.exports = {"section":"StreamExtraBattery_section__n_Feu"};